// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contentContainer__iI0Gmq__50{width:256px}`, "",{"version":3,"sources":["webpack://./src/assets/components/teamPageLegacy/components/presencePopover/presencePopover.module.scss"],"names":[],"mappings":"AAAA,8BACE,WAAA","sourcesContent":[".contentContainer {\n  width: 256px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentContainer": `contentContainer__iI0Gmq__50`
};
export default ___CSS_LOADER_EXPORT___;
